export const TENANT_SETTING_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DRAFT: 'draft',
  DELETED: 'deleted',
} as const

export type TenantSettingStatus = (typeof TENANT_SETTING_STATUS)[keyof typeof TENANT_SETTING_STATUS]

export const TRANSLATION_JOB_SCOPE = {
  POI: 'poi',
  POI_CATEGORY: 'poiCategory',
  TOUR: 'tour',
  DESTINATION: 'destination',
  SURVEY: 'survey',
  SURVEY_VERSION: 'surveyVersion',
  SURVEY_QUESTION: 'surveyQuestion',
  SURVEY_ANSWER: 'surveyAnswer',
  TENANT: 'tenant',
} as const

export const SURVEY_QUESTION_TYPES = {
  FREE_TEXT: 'free_text',
  SINGLE_ANSWER: 'single_answer',
} as const
export type SurveyQuestionType = (typeof SURVEY_QUESTION_TYPES)[keyof typeof SURVEY_QUESTION_TYPES]
export type TranslationJobScope = (typeof TRANSLATION_JOB_SCOPE)[keyof typeof TRANSLATION_JOB_SCOPE]

export const TRANSLATION_JOB_STATUS = {
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const

export type TranslationJobStatus =
  (typeof TRANSLATION_JOB_STATUS)[keyof typeof TRANSLATION_JOB_STATUS]
